// extracted by mini-css-extract-plugin
export default {"tooltip":"_980471565ece951b","arrow":"eb180b10d66f0442"};